import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import BtnWhite from '../../../Shared/Buttons/BtnWhite';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import ConnectionCodePage from './ConnectionCodePage';
import QRCodePage from './QRCodePage';
import TutorialEsim from './TutorialEsim';

const QRCodeOrConnectionCode = (props) => {
  const [isChangePage, setChangePage] = useState(false);
  const [isShowPopUp, setPopUp] = useState(false);
  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div className='qr-code-or-connection-code-main-container'>
      <div className='pink-info'>
        <span className='pink-info-icon'>
          <Image src={require('../EsimIcons/icon-24-light.svg')} />
        </span>
        <span className='pink-info-text'>הנחיות להפעלת ה-eSIM נשלחו גם במייל</span>
      </div>
      {isChangePage ? (
        <ConnectionCodePage
          iContent={props.iContent}
          setPopUp={(isShowPopUp) => setPopUp(isShowPopUp)}
          currentPhone={props?.currentPhone}
          isConnectionCodePage={isChangePage}
          context={props.context}
        />
      ) : (
        <QRCodePage
          iContent={props.iContent}
          setPopUp={(isShowPopUp) => setPopUp(isShowPopUp)}
          currentPhone={props?.currentPhone}
          isConnectionCodePage={isChangePage}
          setChangePage={(bool) => setChangePage(bool)}
          context={props.context}
        />
      )}

      {props?.phoneDataList?.length > 1 ? (
        <div className='footer-button-container'>
          <BtnWhite text='סיימתם? לחצו להפעלת קו אחר' onclick={props.backToChooseNumberPage} />
        </div>
      ) : null}

      <PopUp preventWrapperClose={true} showPopUp={isShowPopUp} onClose={() => setPopUp(false)}>
        <TutorialEsim
          context={props.context}
          iContent={props.iContent}
          props={props}
          isPopUp={true}
          footerButton={<BtnSubmit onclick={() => setPopUp(false)} text='סגור' />}
        />
      </PopUp>
    </div>
  );
};

export default QRCodeOrConnectionCode;
